<template>
  <generic-update :model="model">
    <template v-slot:form="{ error, fetch, item, loading, submit }">
      <person-form
        :with-data="item"
        :error="error"
        :loading="loading"
        @submit="submit"
        @reset="fetch"
      />
    </template>
  </generic-update>
</template>

<script>
import PersonForm from "./Form"
import model from "./model"

export default {
  components: { PersonForm },
  data() {
    return {
      model,
      localData: {},
    }
  },
}
</script>
